import React from 'react';
import './courseCard.css'
import C2wcourseCardDateinfo from './courseCardDateinfo';
import C2wCourseCount from './count';
import { useNavigate } from 'react-router';
import { OFFLINECOURSE, PYTHONOFFLINE, AI_MASTERCLASS, AITOOLBOOTCAMP1, FULLSTACK_COURSE } from '../../../_utils/Routes';

function C2wCourseCard({ obj = null }) {
  const navigate = useNavigate()
  const rendredCoursesCountsCards = obj?.topicArray?.map((objCount, idx) => {
    return <C2wCourseCount obj={objCount} />
  })

  const generateSlug = (name) => {
    return name?.replace(/\s+/g, '-') ?? '';
  };

  return (
    <div className='C2wCourseCard' onClick={() => {
      if (obj?.slug === 'full-stack-development' || obj?.type === 'Fullstack') {
        navigate(FULLSTACK_COURSE);
      } else if (obj?.slug && (obj.slug.startsWith('/') || obj.slug.includes('/'))) {
        navigate(`/${obj.slug.replace(/^\//, '')}`);
      } else if (obj?.type === 'Online') {
        navigate(`/courses/${generateSlug(obj?.slug)}`);
      } else if (obj?.type === 'AI') {
        navigate(`${AITOOLBOOTCAMP1}`);
      } else if (obj?.type === 'Upcoming') {
        if (obj?.slug === 'full-stack-development' || obj?.courseTitle?.toLowerCase().includes('full stack')) {
          navigate(FULLSTACK_COURSE);
        } else {
          navigate(`${FULLSTACK_COURSE}`);
        }
      } else {
        navigate(`${OFFLINECOURSE}/${generateSlug(obj?.slug)}`);
      }
    }}>
      <div className='c2w_image_holder'><img className='C2wCourseCard_thumnnail_img' src={`/assets/images/courses/${obj?.thumbnailImage}`} alt={obj?.thumbnailImage} />
        <div className='C2wCourseCard_feesdiv'>
          {`₹ ${obj?.fees}`}
          <div className='C2wCourseCard_line'></div>
          <div className='C2wCourseCard_feesDivGST'>{obj.type === 'AI' ? 'Incl. GST' : `+ ${obj?.gst}% GST`}</div>
        </div>
      </div>
      <div className='C2wCourseCard_hover_ctn'>
        <C2wcourseCardDateinfo title={obj?.admissionType} validity={obj?.validityType} />
        <div className='C2wCourseCard_hover_Count_ctn'>
          {rendredCoursesCountsCards}
        </div>
      </div>
    </div>
  )
}

export default C2wCourseCard